import { z } from "zod"
import { SmsTarget } from "../SmsTarget"

/**
 * The parts of a customer SMS the API builds itself, handed to the CRM so a
 * composer's character counter measures the exact string that will be sent.
 *
 * Deliberately not reconstructed in the browser: the CRM ships with
 * VITE_MARKETPLACE_URL set to https://julo.se while the API deploys with
 * MARKETPLACE_URL set to https://www.julo.se, so a client-side guess would be
 * four characters short of what the operator actually bills.
 */
export interface SmsPreview {
  target: SmsTarget
  /** Appended to the mechanic's text, e.g. "\nSvara på https://www.julo.se/<jobId>". */
  smsFooter: string
  /** What the customer receives instead when the full text costs more than one SMS. */
  teaser: string
}

export const SmsPreviewQuerySchema = z.object({
  target: z.nativeEnum(SmsTarget).default(SmsTarget.CHAT),
})

export type SmsPreviewQuery = z.infer<typeof SmsPreviewQuerySchema>
